export default __webpack_public_path__ + "static/media/53.2977f73e.gif";